import { render, staticRenderFns } from "./Refresh.vue?vue&type=template&id=52fe7dcb&scoped=true&"
import script from "./Refresh.vue?vue&type=script&lang=js&"
export * from "./Refresh.vue?vue&type=script&lang=js&"
import style0 from "./Refresh.vue?vue&type=style&index=0&id=52fe7dcb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe7dcb",
  null
  
)

export default component.exports